import { SITE } from "../data/site";
import { SERVICES } from "../data/services";
import styles from "./BookingCard.module.css";

export function BookingCard() {
  const requestedSlug =
    typeof window === "undefined" ? null : new URLSearchParams(window.location.search).get("service");
  const requestedService = SERVICES.find((service) => service.slug === requestedSlug);

  return (
    <section id="book" className={styles.section} aria-labelledby="book-heading">
      <div className={`container-wide ${styles.grid}`}>
        <aside className={styles.aside}>
          <h2 id="book-heading" className={styles.heading}>
            {requestedService ? `Book ${requestedService.name} on Vagaro,` : "Book on Vagaro,"}
            <br />
            <em>live availability.</em>
          </h2>
          <p className={styles.body}>
            Vagaro shows Cathryn&apos;s real-time calendar — pick a service, pick a slot, and
            confirm in seconds. No request forms, no waiting on a reply.
          </p>

          <ol className={styles.facts}>
            <li className={styles.fact}>
              <span className={styles.factNo}>01</span>
              <span>{requestedService ? `Confirm ${requestedService.name}.` : "Pick the service you want."}</span>
            </li>
            <li className={styles.fact}>
              <span className={styles.factNo}>02</span>
              <span>Choose an open slot on the live calendar.</span>
            </li>
            <li className={styles.fact}>
              <span className={styles.factNo}>03</span>
              <span>Confirm — Vagaro handles the rest, reminders included.</span>
            </li>
          </ol>
        </aside>

        <div className={styles.card}>
          <p className={styles.cardTitle}>Ready when you are.</p>
          <p className={styles.cardBody}>
            Your appointment books directly on the{" "}
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.vagaroLink}
              aria-label="Vagaro calendar (opens in a new tab)"
            >
              Vagaro calendar
              <span aria-hidden="true">{"\u2197"}</span>
            </a>{" "}
            — every step is live and confirmed instantly.
          </p>

          <div className={styles.actions}>
            <a
              id="book-on-vagaro"
              className="btn btn--primary btn--lg"
              href={SITE.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-describedby="book-on-vagaro-hint"
              aria-label={`${requestedService ? `Book ${requestedService.name}` : "Book"} on Vagaro (opens in a new tab)`}
            >
              {requestedService ? `Book ${requestedService.name} on Vagaro` : "Book on Vagaro"}
              <span aria-hidden="true">{"\u2197"}</span>
            </a>
            <a className="btn btn--secondary btn--lg" href={`tel:${SITE.phoneHref}`}>
              Call {SITE.phone}
            </a>
            <p id="book-on-vagaro-hint" className={styles.outboundHint}>
              Opens vagaro.com in a new tab. Your appointment, confirmation, and reminders are handled there.
            </p>
          </div>

          <p className={styles.note}>
            Questions first? DM{" "}
            <a
              href={SITE.instagramHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              {SITE.instagram}
              <span aria-hidden="true">{"\u2197"}</span>
            </a>{" "}
            on Instagram — replies arrive within one business day.
          </p>
        </div>
      </div>
    </section>
  );
}
